module.exports = __webpack_public_path__ + "static/skipper-charters-tour-b-1-fc1f7a264e9783c35e18cb9d19abccf4.jpg";